import type { CustomCellRendererProps } from "ag-grid-react";
import Department from "src/containers/user/Department";
import type { UID } from "src/types";

interface DepartmentCellRendererProps extends CustomCellRendererProps {
  data: { uid: UID };
}

export const DepartmentCellRenderer = ({
  data,
}: DepartmentCellRendererProps): React.ReactElement => {
  return <Department uid={data.uid} />;
};
